export default __webpack_public_path__ + "static/media/noData-dark.2cb3407b.svg";